export default __webpack_public_path__ + "static/youtube-674842afdc0a366477b5c8316a8b22f4.png";